<template>
  <div class="login-record-page">
    <div class="content-card">
      <div class="card-header">
        <a-icon type="clock-circle" class="header-icon" />
        <div class="header-title">{{ translate('loginRecord.title') }}</div>
      </div>

      <!-- 登录记录表格 -->
      <a-table
        :columns="columns"
        :data-source="datalist"
        rowKey="infoId"
        :loading="dataLoading"
        :pagination="pagination"
        @change="handlePaginationChange"
        size="middle"
        class="custom-table"
      >
      </a-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginRecordPage',
  inject: ['languageState'],
  computed: {
    currentLanguage() {
      return this.languageState ? this.languageState.languageCode : 'zh';
    },
    columns() {
      return [
        {
          title: this.translate('loginRecord.column.username'),
          dataIndex: 'userName',
          key: 'userName',
          width: 150,
        },
        {
          title: this.translate('loginRecord.column.loginTime'),
          dataIndex: 'loginTime',
          key: 'loginTime',
          width: 200,
        },
        {
          title: this.translate('loginRecord.column.ip'),
          dataIndex: 'ipaddr',
          key: 'ipaddr',
          width: 150,
        },
        {
          title: this.translate('loginRecord.column.os'),
          dataIndex: 'os',
          key: 'os',
          width: 150,
        },
        {
          title: this.translate('loginRecord.column.browser'),
          dataIndex: 'browser',
          key: 'browser',
          width: 150,
        },
      ];
    },
  },
  data() {
    return {
      datalist: [],
      rowKey: 'index',
      dataLoading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
        showTotal: (total) => {
          return this.translate('loginRecord.pagination.total', { total });
        },
      },
      timer: '', // 定时器名称
    };
  },
  methods: {
    // 国际化翻译方法
    translate(key, params = {}) {
      const lang = this.currentLanguage;
      const translations = {
        'loginRecord.title': lang === 'zh' ? '登录记录' : 'Login Record',
        'loginRecord.column.username': lang === 'zh' ? '用户名' : 'Username',
        'loginRecord.column.loginTime': lang === 'zh' ? '登录时间' : 'Login Time',
        'loginRecord.column.ip': lang === 'zh' ? 'IP地址' : 'IP Address',
        'loginRecord.column.os': lang === 'zh' ? '操作系统' : 'Operating System',
        'loginRecord.column.browser': lang === 'zh' ? '浏览器' : 'Browser',
        'loginRecord.pagination.total': lang === 'zh' ? `共 ${params.total} 条记录` : `Total ${params.total} records`,
        'loginRecord.message.loginWarning': lang === 'zh' ? '请重新登录！' : 'Please login again!',
      };
      return translations[key] || key;
    },
    // 登录状态检查
    getLoginStatus() {
      this.$request.get('/ums/isLoginStates').then((res) => {
        if (res.data.code === 5000) {
          this.$router.push('/login')
          window.localStorage.clear()
          this.$message.warning(this.translate('loginRecord.message.loginWarning'))
        }
      })
        .catch((e) => {
          console.log(e)
        })
    },
    // 启动定时检查
    start() {
      this.timer = setInterval(this.getLoginStatus, 10000)
    },
    // 获取登录记录数据
    fetchLoginRecordData() {
      this.dataLoading = true;
      this.$request.get('/ums/getLoginRecord', {
        params: {
          pageNum: this.pagination.current,
          pageSize: this.pagination.pageSize,
        },
      }).then((res) => {
        if (res.data.code === 200) {
          this.datalist = res.data.data.list;
          this.pagination.total = res.data.data.total;
        }
      })
        .catch((e) => {
          console.error('获取登录记录失败:', e);
        })
        .finally(() => {
          this.dataLoading = false;
        });
    },
    // 处理分页变化
    handlePaginationChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.fetchLoginRecordData();
    },
  },
  mounted() {
    this.fetchLoginRecordData();
    this.start();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
};
</script>

<style scoped lang="less">
.login-record-page {
  padding: 24px;
  background: #f0f2f5;
  min-height: calc(100vh - 64px);
}

/* 卡片样式 */
.content-card {
  border-radius: 16px;
  margin-bottom: 32px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  background: white;
  border: 1px solid #f5f5f5;
  padding: 16px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    border-color: #e6f7ff;
  }

  :deep(.ant-card-body) {
    padding: 36px;
  }
}

/* 卡片头部 */
.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 2px solid #f0f0f0;
  transition: all 0.3s ease;

  .header-icon {
    font-size: 28px;
    color: #1890ff;
    margin-right: 20px;
    transition: all 0.3s ease;
  }

  .header-title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    letter-spacing: 0.5px;
  }
}

/* 表格样式 */
.custom-table {
  :deep(.ant-table-thead > tr > th) {
    background: #fafafa;
    font-weight: 600;
    border-bottom: 2px solid #f0f0f0;
    padding: 16px 12px;
  }

  :deep(.ant-table-tbody > tr:hover > td) {
    background: #e6f7ff;
  }

  :deep(.ant-table-row) {
    transition: all 0.3s ease;
  }

  :deep(.ant-table-tbody > tr > td) {
    padding: 16px 12px;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .login-record-page {
    padding: 16px;
  }
  
  .content-card {
    :deep(.ant-card-body) {
      padding: 16px;
    }
  }
  
  .card-header {
    margin-bottom: 16px;
    padding-bottom: 16px;

    .header-icon {
      font-size: 24px;
      margin-right: 16px;
    }

    .header-title {
      font-size: 18px;
    }
  }
}
</style>